import Page from '~/components/layout/page/Page';

export default function ProtectionOrderNotProtectedPage() {
  return (
    <Page.Root title="Please Contact Us">
      <p>
        We found your order, but it does not have Shipping Protection, or it has
        been canceled. If you have any questions or need assistance, please
        contact us at{' '}
        <a
          className="text-brand hover:underline"
          href="mailto:support@corso.com"
        >
          support@corso.com
        </a>
        .
      </p>
    </Page.Root>
  );
}
